<template lang="pug">
.register-row.form-label
  .register-group
    .register-key
      span.key-name ADL
      span.validation-label(v-if="required == true") 必須
    .register-value(v-for="adl in _value")
      .d-flex.flex-row.align-items-center.flex-wrap
        .adl-label.mr-2 {{ adl.label }}
        label.register-radio-label
          input.register-radio-form(type="radio" :name="name + '-' + adl.name" :value="'healthiness'"
            :checked="adl.value === 'healthiness'" @change="updateValue(adl.name, 'healthiness')"
            v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName + adl.label : 'ADL：' + adl.label")
          span.register-radio-text 自立
        label.register-radio-label
          input.register-radio-form(type="radio" :name="name + '-' + adl.name" :value="'monitoring'"
            :checked="adl.value === 'monitoring'" @change="updateValue(adl.name, 'monitoring')")
          span.register-radio-text 見守り
        label.register-radio-label
          input.register-radio-form(type="radio" :name="name + '-' + adl.name" :value="'partialAssistance'"
            :checked="adl.value === 'partialAssistance'" @change="updateValue(adl.name, 'partialAssistance')")
          span.register-radio-text 一部介助
        label.register-radio-label
          input.register-radio-form(type="radio" :name="name + '-' + adl.name" :value="'fullAssistance'"
            :checked="adl.value === 'fullAssistance'" @change="updateValue(adl.name, 'fullAssistance')")
          span.register-radio-text 全介助
    
    .error-messages
      .adl-error-message(v-for="adl in _value")
        div(v-for="error in errors.collect(name + '-' + adl.name)")
          label.error-message {{ error }}
          br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

@Component({
  components: {}
})
export default class InputAdl extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: InputAdlModel;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  get _value(): Array<{ value: ADL | null; name: string; label: string }> {
    return [
      { value: this.value.move, name: "move", label: "移動" },
      { value: this.value.meel, name: "meel", label: "食事" },
      { value: this.value.bathing, name: "bathing", label: "入浴" },
      { value: this.value.excretion, name: "excretion", label: "排せつ" }
    ];
  }

  updateValue(adlName: string, newValue: ADL): void {
    const newAdlModel: InputAdlModel = { ...this.value };
    (newAdlModel as any)[adlName] = newValue;
    this.$emit("input", newAdlModel);
  }
}

export interface InputAdlModel {
  /** 移動 */
  move: ADL | null;
  /** 食事 */
  meel: ADL | null;
  /** 入浴 */
  bathing: ADL | null;
  /** 排泄 */
  excretion: ADL | null;
}

export enum ADL {
  /** 自立 */
  HEALTHINESS = "healthiness",
  /** 見守り */
  MONITORING = "monitoring",
  /** 一部介助 */
  PARTIAL_ASSISTANCE = "partialAssistance",
  /** 全介助 */
  FULL_ASSISTANCE = "fullAssistance"
}
</script>

<style scoped>
.adl-label {
  width: 52px;
  font-weight: bold;
}
</style>
